import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { v1 as uuidv1 } from 'uuid';
import { Alert } from 'reactstrap';
import { useTranslation } from 'react-i18next'

import QuestionContainer from './QuestionContainer';
import {
  translateQuestionTypes, defaultQuestion, getQuestion, QuestionShape,
} from './questionTypesConsts';
import useStyles from './styles';


const OpenQuestion = ({
  question: propQuestion, onConfirm, onHide, onGoBack, editMode,
}) => {
  const { t } = useTranslation(['translation']);
  const question = getQuestion(propQuestion);
  const [questionName, setQuestionName] = useState(question.name);
  const [error, setError] = useState(null);

  const { OPEN_QUESTION } = translateQuestionTypes(t);

  const saveQuestion = () => {
    if (questionName === '') {
      setError(t('CAMPAIGN.QUESTIONNAIRE.EMPTY_QUESTION_ERROR'));
      return;
    }
    onConfirm({
      id: uuidv1(),
      name: questionName,
      type: OPEN_QUESTION,
    });
  };

  const onChangeQuestionName = ev => {
    setError(null);
    setQuestionName(ev.target.value);
  };

  const classes = useStyles();
  return (
    <QuestionContainer
      title={OPEN_QUESTION}
      onGoBack={onGoBack}
      saveQuestion={saveQuestion}
      onHide={onHide}
    >
      <div className={classes.questionContainer}>
        <input
          className={classnames(classes.input, classes.questionInput)}
          value={questionName}
          onChange={onChangeQuestionName}
          placeholder={t('CAMPAIGN.QUESTIONNAIRE.QUESTION_PLACEHOLDER')}
          disabled={editMode}
        />
      </div>
      { error && <Alert color="danger">{error}</Alert> }
    </QuestionContainer>
  );
};


OpenQuestion.defaultProps = {
  question: defaultQuestion,
};

OpenQuestion.propTypes = {
  question: QuestionShape,
  onConfirm: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  onGoBack: PropTypes.func.isRequired,
  editMode: PropTypes.bool.isRequired,
};

export default OpenQuestion;
